import React from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@shadcn-in-nx/ui/dialog";
import { Button } from "@shadcn-in-nx/ui/button";
import { UserCheck, MessageCircle, Clock, ArrowRight } from "lucide-react";

export default function HumanSupportTutorial({ isOpen, onClose, onContinue }) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <UserCheck className="h-5 w-5 text-green-600" />
                        Human Support
                    </DialogTitle>
                    <DialogDescription>
                        Get help from a real human expert
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4 py-4">
                    <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
                        <MessageCircle className="h-5 w-5 text-blue-600 mt-0.5" />
                        <div>
                            <h4 className="font-medium text-blue-900 text-sm">
                                Create a Support Ticket
                            </h4>
                            <p className="text-xs text-blue-700 mt-1">
                                Describe your issue and a human expert will help
                                you fix it.
                            </p>
                        </div>
                    </div>

                    <div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
                        <Clock className="h-5 w-5 text-green-600 mt-0.5" />
                        <div>
                            <h4 className="font-medium text-green-900 text-sm">
                                Quick Response Time
                            </h4>
                            <p className="text-xs text-green-700 mt-1">
                                Our team typically responds within 24 hours.
                            </p>
                        </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                        <p className="text-xs text-gray-600">
                            <strong>Free trial:</strong> You get 2 free support
                            tickets to try the service. After that, upgrade to
                            a Human Support plan for unlimited access.
                        </p>
                    </div>
                </div>

                <div className="flex gap-2">
                    <Button variant="outline" onClick={onClose} className="flex-1">
                        Cancel
                    </Button>
                    <Button onClick={onContinue} className="flex-1">
                        Continue
                        <ArrowRight className="h-4 w-4 ml-2" />
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
